import React from 'react';
import { config } from "../../../config"

import { getLogo } from "../../../layouts/layout";

// import img1 from '../../../assets/images/logo-icon-tcs.png';

const Maintanance = () => {
    return <div  className={config.instance.id} id={config.instance.id}>
        <div className="error-box">
            <div className="error-body text-center">
                <img src={getLogo()} alt="logo" width="40" height="40" />
                <h4 className="text-dark font-24">Total control STORE</h4>
                <div className="mt-4">
                    <h3>Your page in under maintenance</h3>
                    <h5 className="mb-0 text-muted font-medium">We are updating the system.</h5>
                    <h5 className="text-muted font-medium">Please check back soon.</h5>
                </div>
                <div className="mt-4 mb-4"><i className="ti-settings font-24"></i></div>
            </div>
        </div>
    </div>;
}

export default Maintanance;
